import { action } from '@ember/object';
import Service, { type Registry as Services, service } from '@ember/service';
import { task } from 'ember-concurrency';
import type { BeniSmartCompset } from 'lumen/models';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import {
  BENI_SMART_COMPSET_BUILDER_MESSAGES,
  type BeniSmartCompsetBuilderMessageType,
} from 'lumen/utils/constants/benchmark-insight/beni-smart-compset-builder-constants';

export default class BenchmarkInsightBeniSmartCompsetServiceService extends Service {
  @service declare alerting: Services['alerting'];
  @service declare errorTracking: Services['error-tracking'];
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;
  @service declare intl: Services['intl'];
  @service declare store: Services['store'];
  @service declare toast: Services['toast'];

  smartCompsetTask = task({ restartable: true }, async () => {
    try {
      const params = {
        typeKey: 'benchmarkinsight/smart_compset',
        subscription_id: this.hotelAndMarketService.hotel.id ?? null,
      };

      return await this.store.queryRecord<BeniSmartCompset>(
        'benchmark-insight/competitors/smart-compset',
        params,
      );
    } catch (error) {
      this.errorTracking.captureException(error);
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.alerting.showErrorAlert();
    }

    return null;
  });

  @action
  displayAlert(
    messageType: BeniSmartCompsetBuilderMessageType,
    isSuccess: boolean,
    smartCompsetName: string,
  ): void {
    const message = BENI_SMART_COMPSET_BUILDER_MESSAGES[messageType];
    // eslint-disable-next-line @typescript-eslint/unbound-method, @typescript-eslint/unbound-method
    const toastMethod = isSuccess ? this.toast.success : this.toast.error;
    toastMethod(this.intl.t(message, { smartCompsetName }), { showIcon: true });
  }
}

declare module '@ember/service' {
  interface Registry {
    'benchmark-insight/beni-smart-compset-service': BenchmarkInsightBeniSmartCompsetServiceService;
  }
}
